export interface FaqItem {
  question: string;
  answer: string;
}

export const faqList: FaqItem[] = [
  {
    question: "《青梅竹马不断向我甜蜜求婚》漫画在哪里可以免费阅读大结局？",
    answer:
      "在89890漫画网即可免费阅读《青梅竹马不断向我甜蜜求婚》全部章节与大结局。进入作品详情页后，点击「大结局 一生一世」章节即可直接开始畅读，无需注册、无需付费。",
  },
  {
    question: "89890漫画网阅读需要收费吗？",
    answer:
      "不需要。89890漫画网提供免费且高清的漫画在线阅读服务，包括连载更新、完结作品与大结局章节，读者可以随时沉浸式阅读。",
  },
  {
    question: "漫画多长时间更新一次？",
    answer:
      "热门连载作品每周更新 1-2 次，更新后会在首页「最新更新」板块第一时间展示。已完结作品则一次性上线全部章节，可随时阅读大结局。",
  },
  {
    question: "在手机上看漫画清晰吗？",
    answer:
      "清晰。89890漫画网采用高清原图加载，自动适配手机与平板屏幕，支持双指放大查看细节，阅读体验流畅。",
  },
  {
    question: "如何找到同类甜宠恋爱漫画？",
    answer:
      "您可以在首页或分类页点击「恋爱」「甜宠」「校园」等分类标签，平台为每个分类提供精选列表与人气排行，方便快速发现喜欢的作品。",
  },
];